<div class="recorder_modal management-add-target competitor-modal">
  <p class="recorder_modal_title">Competitors</p>

  <!-- Existing competitors with an on/off status -->
  <div class="cm-section" *ngIf="competitors.length">
    <span class="cm-label">
      Existing competitors
      <span class="cm-refreshing" *ngIf="loadingCompetitors">· refreshing…</span>
    </span>
    <div class="cm-list">
      <div
        class="cm-item"
        *ngFor="let comp of competitors"
        [class.cm-item--loading]="isLoadingRow(comp)"
      >
        <div class="cm-item_info">
          <span class="cm-item_name">{{ getRowLabel(comp) }}</span>
          <span class="cm-item_url" *ngIf="getRowUrl(comp)">
            {{ getRowUrl(comp) }}
          </span>
        </div>

        <!-- Still crawling its first run — not selectable yet. -->
        <span
          class="cm-item_status cm-item_status--loading"
          *ngIf="isLoadingRow(comp)"
        >
          <span class="cm-spinner"></span> Loading…
        </span>
        <!-- Crawl failed. -->
        <span
          class="cm-item_status cm-item_status--failed"
          *ngIf="isFailedRow(comp)"
        >
          Failed
        </span>
        <!-- Ready — normal on/off toggle. -->
        <mat-slide-toggle
          *ngIf="!isLoadingRow(comp) && !isFailedRow(comp)"
          class="cm-item_toggle"
          [checked]="comp.isActive"
          [disabled]="comp.updating || !comp.competitorId"
          (change)="onToggle(comp, $event)"
        ></mat-slide-toggle>
      </div>
    </div>
  </div>

  <p class="cm-empty" *ngIf="!competitors.length && loadingCompetitors">
    Loading competitors…
  </p>
  <p class="cm-empty" *ngIf="!competitors.length && !loadingCompetitors">
    No competitors added yet.
  </p>

  <!-- Add a new competitor -->
  <div class="cm-add">
    <span class="cm-label">Add competitor</span>

    <label class="custom-input_field_withoutIcon">
      <span class="custom-input_field-label">Name</span>
      <input
        class="custom-input_field"
        matInput
        [(ngModel)]="competitorName"
        type="text"
        placeholder="e.g. Acme Store"
      />
    </label>

    <label class="custom-input_field_withoutIcon">
      <span class="custom-input_field-label">URL</span>
      <input
        class="custom-input_field"
        matInput
        [(ngModel)]="competitorUrl"
        type="text"
        placeholder="https://competitor.com"
      />
    </label>

    <button
      mat-raised-button
      type="submit"
      class="primary cm-add_btn"
      mat-button
      (click)="add()"
      [disabled]="isDisabled()"
    >
      {{ isAdding ? "Adding…" : "Add competitor" }}
    </button>
  </div>

  <div class="cm-footer">
    <button mat-button (click)="close()" class="cm-close">Close</button>
  </div>
</div>
